import { string } from 'prop-types';
import React from 'react';
import { SITE_ORIGIN } from 'constants/site';
import { getCleanPath } from 'util/link';

function PreviewWarning({ path }) {
  const url = `${SITE_ORIGIN}${getCleanPath(path)}`;
  return (
    <div className="PreviewWarning">
      <div>
        This is a preview link. This URL should never be used for any
        promotional activity including social and newsletter, or shared
        publicly.
      </div>
      <div>
        <a href={url}>
          <span>View canonical URL</span>
          <br />
          {url}
        </a>
      </div>
      <style jsx>{`
        .PreviewWarning {
          background: #ff4d56;
          padding: 2rem;
          text-align: center;
          font-family: sans-serif;
        }
        .PreviewWarning div:first-child {
          font-size: 1.25rem;
        }
        .PreviewWarning div {
          display: block;
          margin: 1rem;
        }
        a {
          color: #fff;
          font-size: 0.8rem;
        }
        a span {
          text-transform: uppercase;
        }
      `}</style>
    </div>
  );
}

PreviewWarning.propTypes = {
  path: string.isRequired
};

export default PreviewWarning;
